import { render, staticRenderFns } from "./TabelaPreco.vue?vue&type=template&id=5dd5d4cb"
import script from "./TabelaPreco.vue?vue&type=script&lang=js"
export * from "./TabelaPreco.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports